interface BudgetCaptionProps {
  budget?: number
  currencySymbol?: string
  numGuests: number
}

const BudgetCaption = ({ budget, currencySymbol, numGuests }: BudgetCaptionProps) => {
  if (budget === undefined) return <></>

  const budgetPerPerson = (budget / numGuests).toFixed(2)
  return (
    <p className='caption'>
      This works out as{' '}
      <data value={budgetPerPerson}>
        {currencySymbol}
        {budgetPerPerson}
      </data>{' '}
      per person.
    </p>
  )
}

export default BudgetCaption
